import { render, staticRenderFns } from "./nav-data-source.vue?vue&type=template&id=055813a8&"
import script from "./nav-data-source.vue?vue&type=script&lang=js&"
export * from "./nav-data-source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports